import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useTimeOnPage } from '@3plearning/mx-teacher-analytics/react';
import useAnalyticsClient from './use-analytics-client';
import useAnalyticsIdentity from './use-analytics-identity';

// This module renders a single route, so the page view fires once on mount.
const usePageView = (client) => {
  const trackedRef = useRef(false);

  useEffect(() => {
    if (!client || trackedRef.current) return;

    trackedRef.current = true;
    client.track('page.view', {});
    client.trackSession(window.location.pathname);
  }, [client]);
};

// useTimeOnPage requires a non-null client, so it lives in a child that only mounts once one exists.
const TimeOnPageTracker = ({ client }) => {
  useTimeOnPage(client);

  return null;
};

TimeOnPageTracker.propTypes = {
  client: PropTypes.object.isRequired
};

const AnalyticsListener = () => {
  const client = useAnalyticsClient();

  useAnalyticsIdentity();
  usePageView(client);

  if (!client) return null;

  return <TimeOnPageTracker client={client} />;
};

export default AnalyticsListener;
